// src/utils/generateSOAP.ts

export const xmlSunat = (
  supplierID: string,
  tipo: string,
  serie: string,
  numero: string,
  formattedDate: string,
  monto: string
): string => {
  return `
<soapenv:Envelope xmlns:soapenv="http://schemas.xmlsoap.org/soap/envelope/" xmlns:ser="http://service.sunat.gob.pe">
  <soapenv:Header>
    <wsse:Security xmlns:wsse="http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd">
      <wsse:UsernameToken>
        <wsse:Username>20330791501ARIBAQ24</wsse:Username>
        <wsse:Password>Ariba2424</wsse:Password>
      </wsse:UsernameToken>
    </wsse:Security>
  </soapenv:Header>
  <soapenv:Body>
    <ser:validaCDPcriterios>
      <rucEmisor>${supplierID}</rucEmisor>
      <tipoCDP>${tipo}</tipoCDP>
      <serieCDP>${serie}</serieCDP>
      <numeroCDP>${numero}</numeroCDP>
      <tipoDocIdReceptor>-</tipoDocIdReceptor>
      <fechaEmision>${formattedDate}</fechaEmision>
      <importeTotal>${monto}</importeTotal>
    </ser:validaCDPcriterios>
  </soapenv:Body>
</soapenv:Envelope>`.trim();
};
